export default __webpack_public_path__ + "static/media/Black-Skirt-Blazer.c8880f68.jpg";